import React, { memo, useMemo } from 'react';
import bemit from 'Functions/bemit';
export default memo(function AltLoader(props) {
  if (!props.visible) return null;
  const modifiers = Array.isArray(props.bemit) ? ['alt'].concat(props.bemit) : typeof props.bemit === 'string' && props.bemit ? ['alt'].concat([props.bemit]) : ['alt'];
  const class_name = bemit('c-loader', modifiers) + (props.className ? ' ' + props.className : '');
  return /*#__PURE__*/React.createElement("div", {
    className: class_name
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 2,
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 6,
    strokeOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "1.0s",
    calcMode: "linear",
    dur: "2s",
    repeatCount: "indefinite",
    values: "6;22"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "1.0s",
    calcMode: "linear",
    dur: "2s",
    repeatCount: "indefinite",
    values: "1;0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    begin: "1.0s",
    calcMode: "linear",
    dur: "2s",
    repeatCount: "indefinite",
    values: "2;0"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 6,
    strokeOpacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "2s",
    calcMode: "linear",
    dur: "2s",
    repeatCount: "indefinite",
    values: "6;22"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    begin: "2s",
    calcMode: "linear",
    dur: "2s",
    repeatCount: "indefinite",
    values: "1;0"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    begin: "2s",
    calcMode: "linear",
    dur: "2s",
    repeatCount: "indefinite",
    values: "2;0"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 8
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0s",
    calcMode: "linear",
    dur: "1.0s",
    repeatCount: "indefinite",
    values: "6;1;2;3;4;5;6"
  })))));
});
